import type { FC } from 'react';
import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { Card } from 'react-native-paper';

import { MediaItemImage } from '@/features/media/components/MediaItemImage';
import { MediaItemSize } from '@/features/media/types/mediaItem';
import { usePostCard } from '@/features/posts/components/feed/PostCardContext';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeCardImageStyles = (theme: AppTheme) =>
  StyleSheet.create({
    cover: {
      overflow: 'hidden',
      paddingHorizontal: 0,
      backgroundColor: theme.colors.surfaceContainerLow,
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12
    },
    image: { aspectRatio: 3 / 2 },
    imageTopRadius: { borderTopLeftRadius: 12, borderTopRightRadius: 12 }
  });

export const PostCardImage: FC = () => {
  const { isBlocked, images } = usePostCard();
  const theme = useAppTheme();
  const styles = useMemo(() => makeCardImageStyles(theme), [theme]);
  // Note: Using Card.Cover and aspect ration was requiring to use a wrapper around it to center it, thus opted to use MediaItemImage as it supports loading indicator
  return (
    <Card.Content style={styles.cover}>
      <MediaItemImage
        mediaItem={isBlocked ? undefined : images?.[0]}
        mediaSize={MediaItemSize.MEDIUM}
        style={[styles.image, styles.imageTopRadius]}
      />
    </Card.Content>
  );
};
PostCardImage.displayName = 'PostCardImage';
